export default "__VITE_ASSET__DnLds8$S__"